export const JOB_TYPES = { full_time: "Full-time", part_time: "Part-time", contract: "Contract", freelance: "Freelance", internship: "Internship" };
export const LOCATION_TYPES = { remote_anywhere: "Remote · anywhere", remote_region: "Remote · region / time zone", hybrid: "Hybrid", on_site: "On site" };
export const PAY_PERIODS = { hour: "per hour", week: "per week", month: "per month", year: "per year", project: "per project" };
export const EXPERIENCE = { any: "Any level", entry: "Entry level", mid: "Mid level", senior: "Senior" };

const money = (n, c) => {
  try { return new Intl.NumberFormat(undefined, { style: "currency", currency: c, maximumFractionDigits: 0 }).format(n); } catch { return `${c} ${n}`; }
};

export const payLabel = (j) => `${money(j.pay_min, j.currency)}${j.pay_max ? `–${money(j.pay_max, j.currency)}` : "+"} ${PAY_PERIODS[j.pay_period] || ""}`;
export const whereLabel = (j) => [LOCATION_TYPES[j.location_type], j.location].filter(Boolean).join(" · ");

export const CHANNEL_HINTS = {
  general: "Say hello, ask anything, meet nomads from around the world.",
  looking: "Share what remote work you're looking for and the skills you bring.",
  offering: "Hiring or have overflow work? Post short offers here (full jobs go on the Jobs board).",
  retreats: "Esc Digital Nomad Village retreats, meetups and coworking trips.",
  skills: "Offer your services, swap skills, find collaborators.",
  travel: "Visas, flights, insurance, banking and moving between countries.",
  housing: "Places to stay, coworking spaces and internet that actually works.",
  wins: "Introduce yourself and celebrate first clients, launches and milestones.",
};
